import { Expose } from "class-transformer";

export class UpdateTrainingCategoryDto {
  @Expose()
  name?: string;
}
